import { useScreen } from "layout/ControlLayout";
import StreamView from "components/streaming/StreamView";
import ARCControlMapView from "components/navigation/map/ARCControlMapView";
import { useDeviceFeatureFlags } from "providers/DeviceFeatureFlagsProvider";

const MainScreen = () => {
    const { screen } = useScreen();
    const { flags } = useDeviceFeatureFlags();
    const { HAS_MAP_VIEW } = flags;

    // Container styles from original MainStream
    const containerClass =
        "absolute flex h-full w-full flex-col items-center justify-center bg-black z-0";

    if (HAS_MAP_VIEW && screen === "map") {
        return (
            <div className={containerClass}>
                <ARCControlMapView />
            </div>
        );
    }

    // Default to stream
    return <StreamView className={containerClass} />;
};

export default MainScreen;
